import { RemarkCategoryGeneratedEntity } from "./generated/RemarkCategoryGeneratedEntity";
import { PersonEntity } from "./PersonEntity";

export const REMARK_CATEGORY_ENTITY_TEMPLATE_ID = "C52EBADDF91944CD8DAD7143C63D8E26";

export abstract class RemarkCategoryEntity extends RemarkCategoryGeneratedEntity {
    public get contact(): PersonEntity | null {
        return this.projectMember?.person ?? this.workPackage?.contact ?? this.visitor ?? null;
    }
}
